import { resolveAppApiUrl } from "helper/resolveAppApiUrl"

export const HOST = resolveAppApiUrl() || "https://vtss-station-server-dev.makefamousapp.com"

export const IMAGE_HOST = HOST + 'upload/'
